<div class="container-fluid footer" *ngIf="footer" [ngClass]="{ 'lightest-primary-background': account.accountStyles.inverse_toolbar, 'primary-background': !account.accountStyles.inverse_toolbar }">
  <!-- DYNAMIC FOOTER -->
  <div class="row">
    <div class="section" *ngFor="let row of footer; let i = index;" [ngClass]="getClass(i)">
      <div *ngIf="row.header" class="title-wrapper"><span class="footer-title">{{ row.header }}</span></div>

      <!-- FOOTER LINKS -->
      <div class="footer-link" *ngFor="let item of row.footerLinks">
        <a *ngIf="item.link" [href]="item.link" target="_blank">{{ item.label }}</a>
        <a *ngIf="item.route && item.route.length" [routerLink]="item.route">{{ item.label }}</a>
        <span *ngIf="!item.link && (!item.route || !item.route.length) ">{{ item.label }}</span>
      </div>

      <!-- EMAIL MODULE -->
      <div class="email-module" *ngIf="row.module == 'email'">
        <pv-email-signup [blurb]="row.email.blurb"></pv-email-signup>
      </div>

      <!-- SOCIALS MODULE -->
      <div class="row" *ngIf="row.module == 'socials'">
        <div class="col-12 icons-div">
          <div class="row social-row">
            <div class="col-3 footer-links" *ngFor="let social of row.socials; let i = index">
              <a (click)="trackFooter(i)" rel="noopener" [href]="social.link" target="_blank">
                <i [ngClass]="social.icon"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div [ngClass]="getClass()">
      <span class="saas-ad">Site By <a target="_blank" rel="noopener" href="https://www.dispatchdept.com">Dispatch</a></span>
    </div>
  </div>
</div>